import { apiUrl } from '../api';

// Bundled default journal posts — shown when the API has no blogs yet.
export const STATIC_BLOGS = [
  {
    _id: 'static-cardamom',
    slug: 'why-cardamom-is-the-spice-the-west-forgot',
    category: 'WELLNESS',
    title: 'Why Cardamom is the Spice the West Forgot',
    excerpt: "Elaichi has been used in Ayurvedic medicine for over 3,000 years. Here's why it deserves a place in your daily routine.",
    readTime: '4 min read',
    image: '',
    author: 'Elaichi & Love',
    content:
      "Elaichi - cardamom - has been used in Ayurvedic medicine for over 3,000 years. Long before it became a baking afterthought in the West, it was prized as a digestive aid, a breath freshener, and a warming tonic for body and mind.\n\nIn our karak chai, cardamom does more than flavour. It soothes the gut, calms the nervous system, and connects every cup to a lineage of healing that stretches back generations.\n\nAdd a little elaichi to your daily routine and you are not just chasing taste - you are reclaiming a ritual the West forgot.",
  },
  {
    _id: 'static-charcha',
    slug: 'chai-pe-charcha-how-a-cup-of-tea-builds-communities',
    category: 'COMMUNITY',
    title: 'Chai Pe Charcha: How a Cup of Tea Builds Communities',
    excerpt: 'Our pop-up events have brought together hundreds of people across Glasgow. This is the story behind the movement.',
    readTime: '6 min read',
    image: '',
    author: 'Elaichi & Love',
    content:
      "Chai Pe Charcha - conversation over tea - is the heart of everything we do. Our pop-up events have brought together hundreds of people across Glasgow, one warm cup at a time.\n\nThe best ideas are born over chai. So we created spaces for them: Iftars, festivals, wellness workshops, and community clubs where strangers become friends.\n\nThis is the story behind the movement - and an invitation to join it.",
  },
  {
    _id: 'static-circular',
    slug: 'circular-kitchen-lab-food-with-a-purpose',
    category: 'SUSTAINABILITY',
    title: 'Circular Kitchen Lab: Food With a Purpose',
    excerpt: "Zero waste. Local sourcing. Plastic-free packaging. How we're reimagining what a food business can look like.",
    readTime: '5 min read',
    image: '',
    author: 'Elaichi & Love',
    content:
      "Our Circular Kitchen Lab is built on a simple question: is this good for people and planet?\n\nZero waste. Local sourcing. Plastic-free packaging where we can. Surplus food repurposed into nourishment rather than landfill.\n\nWe believe every food business has a responsibility to the planet - and we are reimagining what that can look like, one decision at a time.",
  },
];

/** All published blogs, newest first. Falls back to the bundled defaults. */
export async function fetchBlogs() {
  try {
    const res = await fetch(apiUrl('/api/blogs'));
    const data = await res.json();
    if (data.success && Array.isArray(data.blogs) && data.blogs.length) return data.blogs;
  } catch { /* fall through */ }
  return STATIC_BLOGS;
}

/** A single blog by slug. Falls back to the bundled defaults. */
export async function fetchBlogBySlug(slug) {
  try {
    const res = await fetch(apiUrl(`/api/blogs/${encodeURIComponent(slug)}`));
    const data = await res.json();
    if (data.success && data.blog) return data.blog;
  } catch { /* fall through */ }
  return STATIC_BLOGS.find((b) => b.slug === slug) || null;
}
